import dayjs from 'dayjs';

import { GetPastConferencesDataType } from '@/api/conference';
import { Donation, Forum, Gallery, Newsletter, Notice, Trend } from '@/api/notice';

import * as S from './style';

export interface ColumnDef {
	key: string;
	title: string;
}

interface TableProps {
	columns: ColumnDef[];
	totalItems: number;
	page: number;
	data: (Gallery | Notice | Forum | Newsletter | Trend | Donation | GetPastConferencesDataType)[];
	onClick?: (pk: number | string) => void;
	onRowClick?: (url: string, pk: string) => void;
}

const getDynamicValue = <T extends Record<string, any>>(obj: T, key: string) => obj[key] ?? '';

const BoardTable = ({ columns, data, onClick, totalItems, page, onRowClick }: TableProps) => (
	<>
		<S.TableContainer>
			<S.Table>
				{columns.map((column, index) => (
					<S.TableHeaderCell key={index}>{column.title}</S.TableHeaderCell>
				))}

				{data.map((row, index) => {
					// 동적으로 pk 가져오기
					const pkKey =
						'gallery_pk' in row
							? 'gallery_pk'
							: 'donation_pk' in row
								? 'donation_pk'
								: 'notice_pk' in row
									? 'notice_pk'
									: 'forum_pk' in row
										? 'forum_pk'
										: 'trend_pk' in row
											? 'trend_pk'
											: 'guide_pk' in row
												? 'guide_pk'
												: 'newsletter_pk';
					const pkValue = getDynamicValue(row, pkKey);

					return (
						<>
							{columns.map((column, i) => {
								// 컬럼에 따라 동적으로 처리
								const columnKey = column.key; // column.key에 따라 다르게 처리
								const value = getDynamicValue(row, columnKey);

								// 'no' 컬럼은 인덱스 + 1
								if (columnKey === 'no') {
									if ('fixed_yn' in row && row?.fixed_yn === '중요') {
										return (
											<S.TableCell key={i}>
												<S.LabelImportant>중요</S.LabelImportant>
											</S.TableCell>
										);
									} else {
										return (
											<S.TableCell key={i} onClick={onRowClick ? () => onRowClick(row.file_path ?? '', String(pkValue)) : () => onClick?.(pkValue)}>
												{' '}
												{totalItems - (page - 1) * 10 - index}
											</S.TableCell>
										);
									}
								}

								// 조회수나 날짜에 대한 포맷 처리
								if (columnKey.includes('hit')) {
									return (
										<S.TableCell key={i} onClick={onRowClick ? () => onRowClick(row.file_path ?? '', String(pkValue)) : () => onClick?.(pkValue)}>
											{value === '' ? '0' : value}
										</S.TableCell>
									);
								}

								if (columnKey.includes('enrollment_date')) {
									return (
										<S.TableCell key={i} onClick={onRowClick ? () => onRowClick(row.file_path ?? '', String(pkValue)) : () => onClick?.(pkValue)}>
											{dayjs(value).format('YYYY-MM-DD')}
										</S.TableCell>
									);
								}
								if (columnKey.includes('title')) {
									return (
										<S.TableCell
											className="start"
											key={i}
											onClick={onRowClick ? () => onRowClick(row.file_path ?? '', String(pkValue)) : () => onClick?.(pkValue)}
										>
											{value}
										</S.TableCell>
									);
								}
								// 나머지 값은 그대로 출력
								return (
									<S.TableCell key={i} onClick={onRowClick ? () => onRowClick(row.file_path ?? '', String(pkValue)) : () => onClick?.(pkValue)}>
										{value}
									</S.TableCell>
								);
							})}
						</>
					);
				})}
			</S.Table>
		</S.TableContainer>
	</>
);

export default BoardTable;
